<template>
  <div>
    <div class="content-container">
      <div class="form-row">
        <div class="form-group col-md-6 col-sm-12">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            v-model="username"
          />
        </div>
        <div class="form-group col-md-6 col-sm-12">
          <input
            type="text"
            class="form-control"
            placeholder="Game Code"
            v-model="gameCode"
          />
        </div>
      </div>
      <button
        class="btn btn-success"
        v-bind:disabled="username === '' || gameCode === ''"
        v-on:click="createGame()"
      >
        <i class="fas fa-plus mr-3"></i>Create Game
      </button>
      <div class="alert alert-danger mt-3" v-if="error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import GameService from "@/services/GameService.js";
import PlayerService from "@/services/PlayerService.js";

export default {
  name: "CreateGame",
  props: ["title"],
  data() {
    return {
      username: "",
      error: "",
      gameCode: "",
    };
  },
  created(){
    this.gameCode = this.generateString(4);
  },
  methods: {
    generateString(length) {
      const characters = "abcdefghijklmnopqrstuvwxyz";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      return result;
    },
    async createGame() {
      // trim username and gameCode
      this.username = this.username.trim();
      this.gameCode = this.gameCode.trim();

      // validate username
      if (!PlayerService.validateUsername(this.username)) {
        this.error =
          "The username may only consist of numbers, uppercase letters and lowercase letters and must be between three and 16 characters long.";
        return false;
      }

      // validate gameCode
      if (!GameService.validateGameCode(this.gameCode)) {
        this.error =
          "The game code may only consist of upper and lower case letters and must be between 3 and ten characters.";
        return false;
      }

      // create game
      try {
        const game = await GameService.createGame(this.gameCode);
      } catch (err) {
        this.error = err.response.data.error;
        return false;
      }

      // create player and redirect to waiting area
      try {
        const player = await PlayerService.createPlayer(this.username);
        this.$store.dispatch("setPlayer", player);

        this.$router.push("/match/" + this.gameCode + "/waiting");
      } catch (err) {
        GameService.deleteGame(this.gameCode);
        this.error = err.response.data.error;
      }
    },
  },
};
</script>
